import styled from 'styled-components';

import { Loading } from '../../../../components/Loading';
import UI from '../../../../domains/UI';
import { useProductIconQuery } from '../../../../Product/graphql';

export type IconProps = {
	id: string;
	name: string;
};

export const ProductImage: React.FC<IconProps> = ({ id, name }) => {
	const { data, error } = useProductIconQuery({
		variables: { productId: id }
	});
	UI.actions.useApolloError(error);

	// if (!data)
	// 	return (
	// 		<div style={{ width: '100px', height: '100px' }}>
	// 			<Loading />
	// 		</div>
	// 	);

	// if (!data?.product) return null;

	return (
		<ImageWrapper>
			{data ? (
				<ItemImage src={data?.product?.icon} alt={name} />
			) : (
				<Loading />
			)}
		</ImageWrapper>
	);
};

const ItemImage = styled('img')`
	object-fit: contain;
	width: 100px;
	height: 100px;
	@media (max-width: 380px) {
		width: 50px;
		height: 50px;
	}
`;

const ImageWrapper = styled.div`
	width: 100px;
	height: 100px;
	@media (max-width: 380px) {
		width: 50px;
		height: 50px;
	}
`;
